import { render, staticRenderFns } from "./letture.vue?vue&type=template&id=d35e9268"
import script from "./letture.vue?vue&type=script&lang=js"
export * from "./letture.vue?vue&type=script&lang=js"
import style0 from "./letture.vue?vue&type=style&index=0&id=d35e9268&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports